export default __webpack_public_path__ + "images/510d4355c1f852b4e942d1afbdc62053.svg";